<template>
    <div id="weekend">
        <h2>【限时折扣】：充{{money}}元得{{voucher+money}}元！！！</h2>
        <div class="aa">
            <div class="b">
                <div class="c">
                    <h3>充{{money}}元得</h3>
                    <h1>{{voucher+money}}<span>元</span></h1>
                </div>
            </div>
            <p class="btn">
                <button @click="doRecharge">立即充值</button>

            </p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Weekend",
        data(){
            return {
                active:44,
                type : 16,
                money : 50,
                voucher : 50
            }
        },methods:{
            doRecharge(){
                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    return ;
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : this.type,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        },
        created(){

            let active = this.$route.params.aid || 44;
            if(active == 23){
                this.money = 15;
                this.voucher = 15;
                this.active = 78;
                this.type = 23;
            }else if(active == 24){
                this.money = 28;
                this.voucher = 28;
                this.active = 79;
                this.type = 24;
            }else if(active == 25){
                this.money = 36;
                this.voucher = 36;
                this.active = 80;
                this.type = 25;
            }else if(active == 26){
                this.money = 66;
                this.voucher = 66;
                this.active = 81;
                this.type = 26;
            }
        }
    }
</script>

<style lang="less">
#weekend{height: 100%;
    min-height: 1500px;background-image: url("http://static.yuread.cn/quick/111.png");background-repeat:no-repeat;background-size:100%;background-color:#ef4040;overflow: hidden;
    h2{font-size: 38px;text-align: center;margin-top:510px;color: #d63f31;}
    .aa{margin: 130px auto 0;width: 710px;height:800px;border-left: 1px solid #f36456;border-right:1px solid #f36456;padding-top: 60px;}
    .b{width: 600px;height:400px;background-color: rgba(255,255,255,.4);margin:0 auto;padding-top: 20px;border-radius: 8px;}
    .c{width: 560px; height:360px;background: #fff;margin:0 auto ;border-radius: 8px;padding:20px 60px;}
    h3{font-size: 80px;color: #D2302C;text-align: center;border-bottom:1px solid #d2302c;font-weight: normal;}
    h1{font-size: 180px;color: #D63E30;text-align: center;
        span{font-size: 60px;}
    }
    .btn{
        text-align: center;margin-top: 50px;
        button{background: linear-gradient(180deg, #FFD595 0%, #FFA050 100%);height: 100px;width:486px;border-radius: 50px;border:none;color: #fff;font-size: 40px;font-weight: 500;}

    }
}
</style>
